/** POS V2 — workflow commandes client (demande → acompte → CMD). */

export const COMMANDES_STEPS = [
  { id: 'search', label: 'Rechercher' },
  { id: 'demande', label: 'Créer demande' },
  { id: 'client', label: 'Client' },
  { id: 'acompte', label: 'Acompte' },
  { id: 'commande', label: 'Commande' },
];

export function buildCommandeCartLine(commande, acompteMontant) {
  const amount = Number(acompteMontant);
  if (!commande?.id || !amount || amount <= 0) return null;
  const piece = commande.piece || commande.designation || 'Commande';
  return {
    produit_ref: `ACOMPTE-CMD-${commande.id}`,
    designation: `Acompte commande — ${piece}`,
    quantite: 1,
    prix_unitaire: amount,
    prix_total: amount,
    stock_magasin_id: null,
    is_acompte: true,
    commande_id: commande.id,
  };
}

export function buildCommandePayload(demande, client, sessionMag) {
  if (!demande?.designation?.trim() || !client?.nom?.trim()) return null;
  const prix = parseFloat(demande.prix);
  if (!prix || prix <= 0) return null;
  const piece = [
    demande.designation.trim(),
    demande.marque && demande.modele ? `${demande.marque} ${demande.modele}` : demande.marque || demande.modele,
  ].filter(Boolean).join(' — ');
  return {
    client_nom: client.nom.trim(),
    client_tel: (client.telephone || '').trim(),
    piece,
    ref_piece: demande.ref_piece || '',
    fournisseur: demande.fournisseur || '',
    quantite: 1,
    prix_final: prix,
    magasin_id: sessionMag || undefined,
  };
}

export function filterActiveCommandes(list, q) {
  const needle = (q || '').trim().toLowerCase();
  if (!needle) return list || [];
  return (list || []).filter((c) => (
    (c.ref_commande || '').toLowerCase().includes(needle)
    || (c.client_nom || '').toLowerCase().includes(needle)
    || (c.piece || '').toLowerCase().includes(needle)
  ));
}

export function defaultAcompteForCommande(cmd) {
  const reste = Number(cmd?.reste_a_payer ?? cmd?.prix_final ?? 0);
  if (!reste || reste <= 0) return '0';
  return String(Math.min(50, reste));
}
